<template>
  <el-row class="header-menu">
    <el-col :span="24" class="header-menu__body">
      <el-row>
        <el-col :span="4">
          <router-link alt="關於我們" to="/about/us">
            關於我們
          </router-link>
        </el-col>
        <el-col :span="4">
          <router-link alt="產品列表" to="/products">
            產品列表
          </router-link>
        </el-col>
        <el-col :span="4">
          <router-link alt="最新消息" to="/news">
            最新消息
          </router-link>
        </el-col>
        <el-col :span="4">
          <router-link alt="聯絡我們" to="/contact-us">
            聯絡我們
          </router-link>
        </el-col>
        <el-col :span="4">
          <a alt="加入社員" href="https://www.hope-coop.org/register">
            加入社員
          </a>
        </el-col>
        <el-col :span="4">
          <a v-if="isLogin" alt="登出" href="#" @click="handleLogout($route.path)">
            登出
          </a>
          <router-link v-else alt="社員登入" :to="{ path: '/auth', query: { redirect: $route.path }}">
            社員登入
          </router-link>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'
export default {
  computed: {
    ...mapGetters(['isLogin'])
  },
  methods: {
    ...mapActions(['clearUser']),
    async handleLogout(redirect) {
      const { account } = api
      await account.logout()
      this.clearUser()
      this.$router.push(redirect || '/')
    }
  }
}
</script>
<style scoped lang="scss">
.header-menu {
  position: absolute;
  width: 60%;
  top: 20px;
  right: 100px;
  &__body {
    padding: 6px 0;
    background: linear-gradient(90deg, rgba(38, 70, 130, 1)0%, $mainPurple 70%);
    color: $white;
    text-align: center;
    a {
      position: relative;
      color: rgba(243, 255, 255, 0.8);
    }
    a:before
      {
        line-height: 19px;
        position: absolute;
        color: #FFF;
        top: 0px;
        left: 0px;
        width: 100%;
        overflow: hidden;
        content: attr(alt);
        transition: all 0.3s;
        transform: scale(0.8);
        opacity: 0;
      }

      a:hover:before
      {
          transform: scale(1);
          opacity: 1;
      }
  }
}
</style>
